import RegisterPasien from "../../components/RegisterPasien/HomePagePasienOnlinePassword";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
